import React, { useContext, useState, useCallback, useEffect, useRef, memo } from 'react';

import * as S from './QuestionnaireStyles';
import { formatCurrency } from '../../../UtilityComponents/Util';
import DisplayContext from '../../../UtilityComponents/displayContext';
import { ResponsiveContainer, Heading, SubTitle, GenericP, GenericSpan } from '../../../common/Styles';
import QuestionnaireForm from './QuestionnaireForm';
import { getMybizQuestions } from '../../landingApi';
import landingContext from '../../landingContext';

import { loadNextComponent } from '../../utils';

const Questionnaire = ({ monetary = {}, updateCurrElem }) => {
	const displayName = useContext(DisplayContext).isMobile;
	const { appSsrData = { bizQues: [] } } = useContext(landingContext) || {};
	const isMobile = displayName == 'mobile';
	const refHtml = useRef();

	const { spend, saving } = monetary;
	const [questions, setQuestion] = useState(appSsrData?.bizQues || []);

	const getDetails = useCallback(async () => {
		if (!appSsrData?.bizQues?.length) {
			const response = await getMybizQuestions();
			setQuestion(response.bizQues);
		}
	}, [setQuestion]);

	useEffect(() => {
		getDetails();
		loadNextComponent(refHtml, updateCurrElem, false, false);
	}, []);

	return (
		<S.Container ref={refHtml} as='section'>
			<ResponsiveContainer className={`${isMobile ? 'paddingLR20' : ''} paddingTB50 `}>
				<S.QuestionnaireWrapper>
					<S.QuestionnaireLeftWrap>
						<Heading
							as='h3'
							color='#c6c6c6'
							font_size={`${isMobile ? '32' : '56'}`}
							marBt={`${isMobile ? '24px' : '65px'}`}>
							Spending more than <GenericSpan fsize={`${isMobile ? '32px' : '56px'}`} right_M='5' color='#3b385e'>{formatCurrency(spend, true)}</GenericSpan>
							every year on Business Travel?
						</Heading>
						<Heading
							as='h2'
							font_size={`${isMobile ? '22' : '44'}`}
							marBt={`${isMobile ? '56px' : ''}`}>
							You could save up to <GenericSpan fsize={`${isMobile ? '22px' : '44px'}`} right_M='5' color='#249995'>{formatCurrency(saving, true)}</GenericSpan>
							!
						</Heading>
					</S.QuestionnaireLeftWrap>
					{questions.length > 0 &&
					<S.QuestionnaireRightWrap>
						<SubTitle
							color='#000'
							fSize={`${isMobile ? '28px' : '32px'}`}
							bottom_M='16'>
							Wondering how you can effectively manage your travel budget?{' '}
						</SubTitle>
						<GenericP fsize={isMobile ? '16px' : '22px'} bottom_M='25'>
							Answer {questions.length} simple questions to download the guidelines
						</GenericP>
						<QuestionnaireForm questions={questions} />
					</S.QuestionnaireRightWrap>}
				</S.QuestionnaireWrapper>
			</ResponsiveContainer>
		</S.Container>
	);
};

export default memo(Questionnaire);
